import account from "./account";
import schemes from "./schemes";
import orders from "./orders";
import contracts from "./contracts";
import transactions from "./transactions";
import createPersistedState from "vuex-persistedstate";
import { FusionProject } from "@/types";

const namespace: FusionProject = "defi";

export const plugins = [
  createPersistedState({
    key: namespace,
    paths: [namespace + ".schemes", namespace + ".account"]
  })
];

export default {
  namespaced: true,
  modules: {
    account,
    schemes,
    orders,
    contracts,
    transactions
  },
  actions: {
    removeDefiData({ dispatch }) {
      dispatch("defi/account/removeWealthes", {}, { root: true });
      dispatch("defi/contracts/removeContracts", {}, { root: true });
      dispatch("defi/orders/removeOrders", {}, { root: true });
      dispatch("defi/transactions/removeTransactions", {}, { root: true });
    }
  }
};
